import PropTypes from 'prop-types';
import { useSelector } from 'react-redux'

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';


const NavGroup = ({ item }) => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const userInfo = JSON.parse(localStorage.getItem("qbarn.user"));

    const items = item.children?.map((menu) => {
        let item_name = menu.id;
        switch (menu.type) {
            case 'collapse':
                if (userInfo !== null &&  userInfo[item_name]) {
                    return <NavCollapse key={menu.id} menu={menu} level={1} />;
                }else{
                    return null
                }

            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;

            case 'other-item':
                if (userInfo !== null &&  userInfo[item_name]) {
                    return <NavItem key={menu.id} item={menu} level={1} />;
                }else{
                    return null
                }

            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            {customization.login && (<List
                subheader={
                    item.title && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                        </Typography>
                    )
                }
            >
                {items}
            </List>)}
            {customization.login && (<Divider sx={{ mt: 0.25, mb: 1.25 }} />)}
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
